import * as XLSX from 'xlsx';

const ExportToExcel = ( jsonData, fileName ) => {  
    console.log("Export data:", jsonData); 
    if (!jsonData || jsonData.length === 0) {        
        return false;
      }
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    
    // Convert JSON data to worksheet
    const worksheet = XLSX.utils.json_to_sheet(jsonData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate a .xlsx file and download it
    XLSX.writeFile(workbook, `${fileName}.xlsx`); 

    return true;
};

export default ExportToExcel;
